<template>
	<div class="flex flex-col md:flex-row mb-1 gap-x-2">
		<slot></slot>
	</div>
</template>
